import Button, { ButtonProps } from "./Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
      // Darker base green (600 → 800) so white text passes the 4.5:1 WCAG
      // contrast threshold without changing the brand hue significantly.
      className={`ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-800 hover:bg-primary-900 text-neutral-50 ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
